var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'genres-list',
        _vm.horScroll && 'genres-list--hor-scroll',
        _vm.horScrollMobile && 'genres-list--hor-scroll-mobile',
        _vm.padded && 'genres-list--padded',
    ]},_vm._l((_setup.extendedGenres),function(genre,index){return _c('div',{key:`genre${index}`,staticClass:"genres-list__item"},[_c('router-link',{staticClass:"genres-list__genre",attrs:{"to":{ name: 'genre', params: { slug: genre.slug } }}},[_vm._v(" "+_vm._s(genre.name)+" ")]),(_vm.hasTypeTitle)?_c('div',{staticClass:"genres-list__type-title"},[_vm._v("Genre")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }